import { render, staticRenderFns } from "./ProductListDetail.vue?vue&type=template&id=65a80ee2&scoped=true&"
import script from "./ProductListDetail.vue?vue&type=script&lang=js&"
export * from "./ProductListDetail.vue?vue&type=script&lang=js&"
import style0 from "./ProductListDetail.vue?vue&type=style&index=0&id=65a80ee2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65a80ee2",
  null
  
)

export default component.exports